import {
  CestaOrigin,
  CestaState,
} from '../../context/reducers/cestaReducer'
import { hasServices } from '../../context/selectors/cestaSelectors'
import {
  hasCestaSelectedTaller,
  shouldSkipTallerSelection,
} from '../../../shared/cesta/cestaTaller'
import route from '../../utils/route'

export { hasCestaSelectedTaller, shouldSkipTallerSelection }

export enum Steps {
  TU_SOLICITUD,
  OPCIONES,
  TALLERES,
  FECHA_HORA,
  REGISTRO,
  PAGO,
  TU_RESERVA,
  MODIFICAR_FECHA_HORA,
  CONFIRMACION_MODIFICACION,
}

/** Pas després de COMPLEMENTOS (o equivalent external). */
export function getNextCestaStepAfterOpciones(state: CestaState): Steps {
  if (state.origin === CestaOrigin.External) {
    return Steps.FECHA_HORA
  }
  if (shouldSkipTallerSelection(state)) {
    return Steps.FECHA_HORA
  }
  return Steps.TALLERES
}

/** Pas des de TU_SOLICITUD quan la cesta no té serveis opcionals. */
export function getNextCestaStepWithoutServices(state: CestaState): Steps {
  if (shouldSkipTallerSelection(state)) {
    return Steps.FECHA_HORA
  }
  return Steps.TALLERES
}

/** Pas «enrere» des de FECHA Y HORA quan el taller ja ve del buscador/cesta. */
export function getPrevCestaStepBeforeFechaHora(state: CestaState): Steps {
  if (state.origin === CestaOrigin.External) {
    return Steps.OPCIONES
  }
  if (shouldSkipTallerSelection(state)) {
    return hasServices(state) ? Steps.OPCIONES : Steps.TU_SOLICITUD
  }
  return Steps.TALLERES
}

export const DataSteps = [
  {
    step: Steps.TU_SOLICITUD,
    name: 'steps_cesta.tu_solicitud',
    route: route('cesta.solicitud'),
    prev: () => Steps.TU_SOLICITUD,
    visible: true,
  },
  {
    step: Steps.OPCIONES,
    name: 'steps_cesta.opciones',
    route: route('cesta.opciones'),
    prev: () => Steps.TU_SOLICITUD,
    visible: true,
  },
  {
    step: Steps.TALLERES,
    name: 'steps_cesta.talleres',
    route: route('cesta.talleres'),
    prev: (state: CestaState) =>
      hasServices(state) ? Steps.OPCIONES : Steps.TU_SOLICITUD,
    visible: true,
  },
  {
    step: Steps.FECHA_HORA,
    name: 'steps_cesta.fecha_y_hora',
    route: route('cesta.fecha_hora'),
    prev: (state: CestaState) => getPrevCestaStepBeforeFechaHora(state),
    visible: true,
  },
  {
    step: Steps.REGISTRO,
    name: 'steps_cesta.registro',
    route: route('cesta.registro'),
    prev: () => Steps.FECHA_HORA,
    visible: true,
  },
  {
    step: Steps.PAGO,
    name: 'steps_cesta.pago',
    route: route('cesta.pago'),
    prev: () => Steps.FECHA_HORA,
    visible: true,
  },
  {
    step: Steps.TU_RESERVA,
    name: 'steps_cesta.reserva',
    route: route('cesta.tu_reserva'),
    prev: () => -1,
    visible: true,
  },
  {
    step: Steps.MODIFICAR_FECHA_HORA,
    name: 'steps_cesta.modificar_fecha_hora',
    route: route('cesta.modificar_fecha_hora'),
    prev: () => -1,
    visible: false,
  },
  {
    step: Steps.CONFIRMACION_MODIFICACION,
    name: 'steps_cesta.confirmacion_modificacion',
    route: route('cesta.confirmacion_modificacion'),
    prev: () => -1,
    visible: false,
  },
]

export function stepFromRoute(path: string) {
  for (let i = DataSteps.length - 1; i >= 0; i--) {
    const s = DataSteps[i]
    if (s.route === path) {
      return s
    }
  }

  return null
}
